export const isEmpty = (value: unknown) =>
  value === undefined || value === null || value === '' || (typeof value === 'string' && value.trim() === '');
